import { Button, Flex, Icon, IconButton, Popover, PopoverArrow, PopoverContent, PopoverTrigger, Portal } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaTrashAlt } from "react-icons/fa";

interface Props {
  confirmRemoval: () => Promise<void>;
  size?: string;
}

export const RemoveFileButton = ({ confirmRemoval, size }: Props) => {
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  return (
    <Flex>
      <Popover
        returnFocusOnClose={true}
        isOpen={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        placement="bottom"
        closeOnBlur={true}
        offset={[0, -3]}
      >
        <PopoverTrigger>
          <IconButton
            aria-label="Remove file"
            display="flex"
            alignItems="center"
            justifyContent="center"
            variant="ghost"
            color="smMuted"
            size={size}
            onClick={(e) => {
              e.stopPropagation();
              setShowConfirmation(true);
            }}
            icon={<Icon as={FaTrashAlt} />}
          />
        </PopoverTrigger>
        <Portal>
          <PopoverContent width="fit-content" p="1">
            <PopoverArrow />
            <Button
              rightIcon={<Icon as={FaTrashAlt} />}
              colorScheme="red"
              variant="ghost"
              size={size}
              isLoading={isDeleting}
              onClick={async (e) => {
                e.stopPropagation();
                setIsDeleting(true);
                try {
                  await confirmRemoval();
                } finally {
                  setIsDeleting(false);
                  setShowConfirmation(false);
                }
              }}
            >
              {t("Confirm")}
            </Button>
          </PopoverContent>
        </Portal>
      </Popover>
    </Flex>
  );
};
